import makeStyles from '@material-ui/core/styles/makeStyles'
import ClientServiceSideMenu from '../3modules/ServiceSetImport/ClientServiceSideMenu'
import ServiceForm from '../3modules/ServiceImport/ServiceForm'
import {CancelButton, NextButton, PrevButton} from '../1elements'
import {useEffect, useState} from 'react'
import ApiService from '../../common/ApiCalls'
import {getItemFromSessionStorage} from '../../services/util/sessionStorageManager'
import SelectApproverModal from '../3modules/SmartForm/SelectApproverModal'
import ErrorSnackbar from '../2compounds/ErrorSnackbar'
import FormSuccessSnackbar from '../2compounds/FormSuccessSnackbar'
import SelectServiceTypeInstruction from '../3modules/ServiceImport/SelectServiceTypeInstruction'
import RejectButton from '../1elements/Buttons/TextButtons/RejectButton'
import ApproveButton from '../1elements/Buttons/TextButtons/ApproveButton'
import RejectModal from '../2compounds/RejectModal'
import ApproveModal from '../2compounds/ApproveModal'
import uuid from 'react-uuid'

const useStyles = makeStyles({
    root: {
        display: 'grid',
        gridTemplateColumns: '20% 80%',
        width: '100%',
        height: '100%'
    },
    formDiv: {
        padding: '20px'
    },
    buttonDiv: {
        position: 'absolute',
        bottom: '20px',
        right: '20px',
        display: 'flex',
        '&>*': {
            marginLeft: '30px'
        }
    }
})

const ServiceImportTemplate = ({disabled, serviceList, setServiceList, onCancel, onSave, onPrev, options, selectedServiceType,
                                setSelectedServiceType, setSelectedServiceTypeId, setSearchKeyword, showError, onReject, onApprove,
                                isModalOpen, setIsModalOpen, onNext, approver, setApprover, formCheckSnackbar, setFormCheckSnackbar}) => {
    const classes = useStyles()
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false)
    const [selectedService, setSelectedService] = useState(null)
    const [rejectModalOpen, setRejectModalOpen] = useState(false)
    const [approveModalOpen, setApproveModalOpen] = useState(false)
    const selectServiceType = (selectedServiceType) => {
        setSelectedServiceType(selectedServiceType)
    }
    const [serviceData, setServiceData] = useState({
        'id': uuid(),
        'serviceName': '',
        'serviceDescription': '',
        'attachmentTitle': '',
        'attachmentUrl': '',
        'selected': false
    })
    const addService = (newValue) => {
        const serviceListCopy = {...serviceList}
        if(serviceListCopy[selectedServiceType]){
            serviceListCopy[selectedServiceType].push(newValue)
        }else{
            serviceListCopy[selectedServiceType] = new Array(newValue)
        }
        setServiceList(serviceListCopy)
        setIsSnackbarOpen(true)
    }
    const deleteService = (serviceType, index) => {
        let serviceListCopy = {...serviceList}
        serviceListCopy[serviceType].splice(index, 1)
        setServiceList(serviceListCopy)
    }

    const setInput = (serviceType, index) => {
        setServiceData(serviceList[serviceType][index])
        setSelectedServiceType(serviceType)
    }

    const openRejectModal = () => {
        setRejectModalOpen(true)
    }

    const openApproveModal = () => {
        setApproveModalOpen(true)
    }

    const handleReject = () => {
        setRejectModalOpen(false)
        onReject()
    }

    const handleApprove = () => {
        setApproveModalOpen(false)
        onApprove()
    }

    useEffect(()=> {
        const dataFromStorage = getItemFromSessionStorage('selectedServiceList')
        if(!dataFromStorage){
            ApiService().getAllServiceTypes()
                .then((res)=>{
                    let serviceType = res
                    for(let i = 0; i<serviceType.length; i++){
                        setServiceList(prevState => {return{...prevState, [serviceType[i]['service_type']]: []}})
                    }
                })
                .catch((err)=>{
                    console.log(err)
                })
        }else{
            setServiceList(dataFromStorage)
        }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [])

    return(
        <div className={classes.root}>
            <ClientServiceSideMenu disabled={disabled} deleteService={deleteService} selectServiceType={selectServiceType}
                                   serviceList={serviceList} setInput={setInput} selectedService={selectedService}
                                   setSelectedService={setSelectedService} setSelectedServiceTypeId={setSelectedServiceTypeId} />
            <div className={classes.formDiv}>
                {
                    selectedServiceType
                        ? (
                            <ServiceForm selectedServiceType={selectedServiceType} options={options}
                                         onChangeAutocomplete={addService} selectedService={selectedService}
                                         setSelectedService={setSelectedService} setSearchKeyword={setSearchKeyword}
                                         disabled={disabled} serviceData={serviceData}/>
                        )
                        : (
                            <SelectServiceTypeInstruction />
                        )
                }
                <div className={classes.buttonDiv}>
                    {onPrev && (<PrevButton onClick={onPrev} />)}
                    {onCancel && (<CancelButton onClick={onCancel} />)}
                    {onNext && (<NextButton onClick={onNext} />)}
                    {onReject && (<RejectButton onClick={openRejectModal} /> )}
                    {onApprove && (<ApproveButton onClick={openApproveModal} /> )}
                </div>
            </div>
            <ErrorSnackbar setIsSnackbarOpen={setFormCheckSnackbar} isSnackbarOpen={formCheckSnackbar} message={'Attach at least one service'} />
            <FormSuccessSnackbar isSnackbarOpen={isSnackbarOpen} setIsSnackbarOpen={setIsSnackbarOpen} />
            <SelectApproverModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} showError={showError}
                                 onSubmit={onSave} approver={approver} setApprover={setApprover} />
            <RejectModal rejectHandler={handleReject}
                         open={rejectModalOpen}
                         setOpen={setRejectModalOpen} />
            <ApproveModal approveHandler={handleApprove}
                          open={approveModalOpen}
                          setOpen={setApproveModalOpen} />
        </div>
    )
}

export default ServiceImportTemplate